import request from "@/utils/request";

export function listStuCurriculumScore(query) {
  return request({
    url: "/stuc/stucurriculumscore/list",
    method: "get",
    params: query,
  });
}

export function listStuCurriculumScoreWarning(query) {
  return request({
    url: "/stuc/stucurriculumscore/warn_list",
    method: "get",
    params: query,
  });
}

export function getStuCurriculumScore(id) {
  return request({
    url: "/stuc/stucurriculumscore/get?id=" + id,
    method: "get",
  });
}

export function addStuCurriculumScore(data) {
  return request({
    url: "/stuc/stucurriculumscore/add",
    method: "post",
    data: data,
  });
}

export function editStuCurriculumScore(data) {
  return request({
    url: "/stuc/stucurriculumscore/edit",
    method: "post",
    data: data,
  });
}

export function delStuCurriculumScore(ids) {
  return request({
    url: "/stuc/stucurriculumscore/del",
    method: "post",
    data: {
      ids: ids,
    },
  });
}
